import './NavMenu.scss';
import React, { memo, useMemo } from 'react';
import { AppState } from 'core/redux/reducers';
import { useSelector } from 'react-redux';
import {
  INavMenu,
  makeSelectNavIsActive,
  makeSelectNavMenu,
  NavMenuTypes,
  NavTypes,
} from 'core/redux/features/shared/nav';
import PropUpPage from 'Components/PopUpPage';
import ChangeLocaleBox from './ChangeLocaleBox';

function MenuItemsComp({
  items,
  label,
}: {
  items: INavMenu[];
  label?: string;
}) {
  return (
    <>
      {label ? <p className="menu-label">{label}</p> : null}
      <ul className="menu-list">
        {items.map((item, index) => {
          const icon = item.settings?.icon;
          const isHideInApp = item.settings?.hide_in_app === 'hide_in_app';
          return (
            <li key={index} className={isHideInApp ? 'menu--hideapp' : ''}>
              {item.type === 'menu_item' ? (
                <a className={icon ? 'has-icon' : ''} href={item.link}>
                  {icon ? (
                    <span className="icon is-left eb eb-circle">
                      <span className={icon} />
                    </span>
                  ) : null}
                  <span dangerouslySetInnerHTML={{ __html: item.title }} />
                </a>
              ) : (
                <p className="menu-label">{item.title}</p>
              )}
            </li>
          );
        })}
        <ChangeLocaleBox />
      </ul>
    </>
  );
}

const NavMenu = memo(() => {
  const selectNavMenu = useMemo(makeSelectNavMenu, []);
  const { mainMenus, show } = useSelector((state: AppState) => ({
    mainMenus: selectNavMenu(state, NavMenuTypes.main),
    show: makeSelectNavIsActive()(state, NavTypes.Menu),
  }));

  return (
    <PropUpPage
      whiteBackdrop={true}
      hide={!show}
      className="menu is-mobile menu--main"
    >
      <MenuItemsComp items={mainMenus} />
    </PropUpPage>
  );
});

export default NavMenu;
